import React from 'react';
import PropTypes from 'prop-types';
import { CONVERTTIME } from '../../../../utils/dateController';
import '../../../../css/registrationList.css';

function createData(
  membershipID, firstName, lastName, email, phone, registrationDate, paymentStatus,
) {
  return {
    membershipID, firstName, lastName, email, phone, registrationDate, paymentStatus,
  };
}

function getRegistrationMembers(registration) {
  if (registration.familyMembersData && registration.familyMembersData.length > 0) {
    return registration.familyMembersData;
  }
  if (registration.membershipData && registration.membershipData.familyMembersInformation && registration.membershipData.familyMembersInformation.length > 0) {
    return [registration.membershipData.familyMembersInformation[0]];
  }
  return [];
}

function getRegistrationRows(registrationData) {
  const rows = [];
  for (let i = 0; i < registrationData.length; i++) {
    const registration = registrationData[i];
    const members = getRegistrationMembers(registration);
    for (let memberIndex = 0; memberIndex < members.length; memberIndex++) {
      const member = members[memberIndex];
      rows.push(createData(
        registration.membershipID,
        member.firstName || '',
        member.lastName || '',
        registration.membershipData ? registration.membershipData.email : '',
        member.phone || '',
        CONVERTTIME(registration.registrationDate, true),
        registration.paymentStatus,
      ));
    }
  }
  return rows;
}

function filterRows(rows, sortStatus, sortSearch) {
  const normalizedSearch = sortSearch ? sortSearch.toLowerCase() : '';
  return rows.filter((row) => {
    const statusMatches = sortStatus.length < 1
      || sortStatus.some((status) => status.toLowerCase() === row.paymentStatus.toLowerCase());
    if (!statusMatches) return false;
    if (!normalizedSearch) return true;
    return (
      row.firstName.toLowerCase().includes(normalizedSearch)
      || row.lastName.toLowerCase().includes(normalizedSearch)
      || row.email.toLowerCase().includes(normalizedSearch)
      || row.membershipID.includes(sortSearch)
    );
  });
}

export default function RegistrationTableExport({
  registrationData,
  sortStatus,
  sortSearch,
}) {
  const data = filterRows(getRegistrationRows(registrationData), sortStatus, sortSearch);

  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Membership ID</th>
            <th scope="col">First Name</th>
            <th scope="col">Last Name</th>
            <th scope="col">Email</th>
            <th scope="col">Phone</th>
            <th scope="col">Registration Date</th>
            <th scope="col">paymentStatus</th>
          </tr>
        </thead>
        <tbody>


          {data.map((value, index) => (
            <tr key={index}>
              <td>
                {value.membershipID}
              </td>
              <td>
                {value.firstName}
              </td>
              <td>
                {value.lastName}
              </td>
              <td>
                {value.email}
              </td>
              <td>
                {value.phone}
              </td>
              <td>
                {CONVERTTIME(value.registrationDate, true)}
              </td>
              <td>
                {value.paymentStatus}
              </td>
            </tr>
          ))}

        </tbody>
      </table>
    </div>
  );
}

RegistrationTableExport.propTypes = {
  sortStatus: PropTypes.arrayOf(PropTypes.string).isRequired,
  sortSearch: PropTypes.PropTypes.string.isRequired,
  registrationData: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      familyMembers: PropTypes.arrayOf(PropTypes.shape({
        phone: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        membershipID: PropTypes.string,
      })),
    }),
  ]).isRequired,
};
